module.exports = __webpack_public_path__ + "static/media/EFIDE.ea83b571.png";